// extracted by mini-css-extract-plugin
export default {"colored-button":"ColoredButton_colored-button__aoW50"};